// Re-use for Component's without a Layout
export default function EmptyLayout({children}) {
  return children
}
